"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.buttonStates = void 0;

var _react = _interopRequireWildcard(require("react"));

var _SponsorCard = require("./SponsorCard.styled");

var _ga = require("../services/ga");

var _getCookie = require("../services/getCookie");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var buttonStates = ['initial', 'processing', 'submitted'];
exports.buttonStates = buttonStates;

function SponsorCard(_ref) {
  var content = _ref.content;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      minHeightTalkDesc = _useState2[0],
      setMinHeightTalkDesc = _useState2[1];

  var _useState3 = (0, _react.useState)(buttonStates[0]),
      _useState4 = _slicedToArray(_useState3, 2),
      buttonState = _useState4[0],
      setButtonState = _useState4[1];

  var buttonListRef = (0, _react.useCallback)(function (node) {
    if (node !== null && window.matchMedia('(min-width: 600px)').matches) {
      setMinHeightTalkDesc(node.getBoundingClientRect().height);
    }
  }, []);
  var sponsor = content.data;
  var email = (0, _getCookie.getCookie)('watchMail');

  var handleClick = function handleClick(e) {
    e.preventDefault();

    if (buttonState === buttonStates[0]) {
      (0, _ga.trackGAEvent)('sponsor-consent', 'click', "name:".concat(sponsor.itemID), content.isAuth);
      setButtonState(buttonStates[1]);

      try {
        fetch("https://script.google.com/macros/s/AKfycbxxLif_AS3Pz_WGZbYmkHla-FQdNhFUVYaJFPPJvhceE_TAdb_9dnMPVBpbLVOlGZJ6/exec?sponsor=".concat(sponsor.itemID, "&email=").concat(email), {
          method: 'POST'
        }).then(function () {
          setButtonState(buttonStates[2]);
        });
      } catch (error) {
        setButtonState(buttonStates[0]);
        throw new Error("Failed recording attendee email consent: ".concat(error.toString()));
      }
    }

    return false;
  };

  return /*#__PURE__*/_react.default.createElement(_SponsorCard.PopSponsor, null, /*#__PURE__*/_react.default.createElement(_SponsorCard.PopSponsorTop, null, /*#__PURE__*/_react.default.createElement(_SponsorCard.PopSponsorLogo, {
    src: sponsor.image.url
  }), /*#__PURE__*/_react.default.createElement(_SponsorCard.PopSponsorActions, null, /*#__PURE__*/_react.default.createElement("div", {
    ref: buttonListRef
  }, /*#__PURE__*/_react.default.createElement(_SponsorCard.PopSponsorBtn, {
    disabled: buttonState !== buttonStates[0],
    state: buttonState,
    onClick: email ? handleClick : function () {
      (0, _ga.trackGAEvent)('sponsor-consent', 'click', "no-email", content.isAuth);
    },
    href: email ? '#' : sponsor.registerLink,
    target: "_blank"
  }, buttonState === buttonStates[0] ? "I'm interested" : buttonState === buttonStates[2] ? 'Recorded' : 'Processing'), email && /*#__PURE__*/_react.default.createElement(_SponsorCard.PopSponsorBtnDisclaimer, null, "allow ", sponsor.itemID, " to send you more details over email")))), /*#__PURE__*/_react.default.createElement(_SponsorCard.PopSponsorMid, {
    minHeight: minHeightTalkDesc
  }, /*#__PURE__*/_react.default.createElement(_SponsorCard.PopSponsorTitle, {
    dangerouslySetInnerHTML: {
      __html: sponsor.title
    }
  }), /*#__PURE__*/_react.default.createElement(_SponsorCard.PopSponsorBio, {
    dangerouslySetInnerHTML: {
      __html: sponsor.subtitle
    }
  }), /*#__PURE__*/_react.default.createElement(_SponsorCard.PopSponsorPerk, {
    dangerouslySetInnerHTML: {
      __html: sponsor.description
    }
  }), /*#__PURE__*/_react.default.createElement(_SponsorCard.PopSponsorPerkBtn, {
    href: sponsor.registerLink,
    target: "_blank",
    onClick: function onClick() {
      (0, _ga.trackGAEvent)('sponsors-offers', 'click', "name:".concat(sponsor.itemID), content.isAuth);
    },
    dangerouslySetInnerHTML: {
      __html: sponsor.location
    }
  })));
}

var _default = SponsorCard;
exports.default = _default;